module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@3x-56d71595b97429472a475a7273ba5ccc.png";